export const CLONE_TABLE_ROW_HEIGHT = 90;
export const CLONE_TABLE_PANEL_HEADER_HEIGHT = 45;
export const CLONE_TABLE_GRID_HEADER_HEIGHT = 45;
